// PRD 08 §10 — apply a resolved CorpusConfig to a DOM root by setting
// data-maisight-* attributes. Tokens.css + accents.css pick the rest up via
// attribute selectors; no React-tree rerender needed for the visual flip.
//
// Shared between ReadingPage (sets attrs on documentElement) and the embed
// widget (sets attrs on the shadow root host so styles scope to the mount).

import type { CorpusConfig } from "../data/types";

export function applyConfig(root: HTMLElement, c: CorpusConfig): void {
  root.dataset.glossaTheme = c.theme;
  root.dataset.glossaAccent = c.accent;
  root.dataset.glossaTypeScale = c.type_scale;
  root.dataset.glossaDefaultRegister = c.default_register;
  root.dataset.glossaRailMode = c.rail_position;
}
